/**
 * @generated SignedSource<<c080d191f2ae4a5d80c24e0f3470c0e9>>
 * @relayHash 79d5cab63eb4a3170b1258a3378c10a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 05d2a553796491a4c21658368b72ff32f411f685ed0c6333a6b075025f9d85bc

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ProductsJsmWorkforceSkillsPageSiteWfoStatusQuery } from './ProductsJsmWorkforceSkillsPageSiteWfoStatusQuery.graphql';

const node: PreloadableConcreteRequest<ProductsJsmWorkforceSkillsPageSiteWfoStatusQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "05d2a553796491a4c21658368b72ff32f411f685ed0c6333a6b075025f9d85bc",
    "metadata": {},
    "name": "ProductsJsmWorkforceSkillsPageSiteWfoStatusQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
